import { useModuleBEM } from "@b2bportal/core-themes";
import type { PlatformComponentProps } from "@b2bportal/core-types";
import { useI18nContext } from "@hopper-b2b/i18n";
import {
  Button,
  ButtonTypeEnum,
  Dialog,
  DialogContent,
  DialogClose,
  DialogTrigger,
} from "@tenant/ui";
import clsx from "clsx";
import { ApacUiComponent } from "../../context";
import { useApacUiStyles } from "../../hooks";
import { NumberSelector } from "../NumberSelector";
import defaultStyles from "./NumberPickerDialog.module.scss";

interface NumberPickerDialogProps extends PlatformComponentProps {
  dialogTitle?: string;
  label: string;
  defaultValue?: number;
  minimumValue?: number;
  maximumValue?: number;
  updateCount: (num: number) => void;
}

export const NumberPickerDialog = (props: NumberPickerDialogProps) => {
  const {
    dialogTitle,
    label,
    defaultValue,
    minimumValue,
    maximumValue,
    updateCount,
    className,
    children,
  } = props;
  const styles = useApacUiStyles(
    ApacUiComponent.NumberPickerDialog,
    defaultStyles
  );
  const [block, cn] = useModuleBEM(styles, ApacUiComponent.NumberPickerDialog);
  const { t } = useI18nContext();
  return (
    <Dialog>
      <DialogTrigger asChild>{children}</DialogTrigger>
      <DialogContent
        title={dialogTitle}
        className={clsx(
          block,
          className,
          cn("dialog-title", { missing: dialogTitle == null })
        )}
      >
        <div className={cn("content")}>
          <div className={cn("label")}>{label}</div>
          <NumberSelector
            className={cn("number-selector")}
            decrementButton={{
              ariaLabel: t("apac.number.decrement"),
            }}
            incrementButton={{
              ariaLabel: t("apac.number.increment"),
            }}
            defaultValue={defaultValue}
            minimumValue={minimumValue}
            maximumValue={maximumValue}
            onChange={updateCount}
          />
        </div>
        <div className={cn("action")}>
          <DialogClose asChild>
            <Button
              buttonType={ButtonTypeEnum.Primary}
              className={cn("closeButton")}
            >
              {t("confirm")}
            </Button>
          </DialogClose>
        </div>
      </DialogContent>
    </Dialog>
  );
};
